import { createApp } from 'vue';
import MessageToSentry from '@component_path/lib/messageToSentry';
import MultiStepBox from '@component_path/business_aptitudes';
import { createRouter, createWebHistory } from 'vue-router';
import TendencyStep from '@component_path/business_aptitudes/components/TendencyStep';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('multi-step-box-data');
  const props = JSON.parse(node.getAttribute('data'));

  /* router */
  const tendencyCount = props.masterData.tendencyTexts.length;
  const tendencyPaths = [...Array(tendencyCount)].map((_, index) => {
    const order = index + 1;
    return { path: `/step${order}`, name: `step${order}`, component: TendencyStep, meta: { textIndex: index, order: order } };
  });
  const routes = [].concat(
    tendencyPaths
  )
  const basePath = props.basePath; // = /1st/20xx/jobmatch/
  const router = createRouter({
    history: createWebHistory(basePath),
    routes: routes
  })
  /* router end */

  const app = createApp(MultiStepBox, props);
  app.config.errorHandler = MessageToSentry.fromVueInstance;
  app.use(router);
  app.mount('#multi-step-box');
});
